import React  from 'react';
import {
  DataTable, IconTrash,
} from '@skf/bt-wind-rail-commonlibrary';
import { useTranslation } from 'react-i18next';
import { SelectedRoleInfo } from '../../../../../store/roles/types';
import style from './UserManagementAssignRolesDataTable.module.scss';

interface IUserManagementAddProps {
  roles: SelectedRoleInfo[];
  onDeleteRole: (role: SelectedRoleInfo) => any;
  className?: string;
}

const UserManagementAssignRolesDataTable: React.FunctionComponent<IUserManagementAddProps> = (
  {
    roles,
    onDeleteRole,
  }
) => {
  const { t } = useTranslation();

  const columns: any[] = [
    {
      Header: t('Industry'),
      accessor: 'industryText',
    },
    {
      Header: t('Country'),
      accessor: 'siteCountryDescription',
    },
    {
      Header: t('Company'),
      accessor: 'companyName',
    },
    {
      Header: t('Plant/Site'),
      accessor: 'plantUnitDescription',
    },
    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,
      className: style.columnActions,
      Cell: ({ row }: any) => {
        const { original: role } = row;
        return (
          <IconTrash
            className={style.cursorPointer}
            onClick={() => onDeleteRole(role)}
          />
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={roles}
      className={style.table}
      pagination={20}
    />
  );
};

export default UserManagementAssignRolesDataTable;
